import CustomList from "../Util/List/CustomList/CustomList";
import CustomListContainer from "../Util/List/CustomList/CustomListContainer";
import config from "../../../../application/config/config";

function List() {
  const pathFrontEnd = '/core/dbmigrations/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointDelete: `${config.endpoints.backend}core/dbmigrations/delete`,
    endpoint: config.endpoints.backend + 'core/dbmigrations/getall'
  }

  let list = {
    labelTitle: "Lista de Migrations",
    fieldsShowOnDelete: [""],
    showPrintButtons: true,
    viewActionColumn: false,
    canAdd: false,
    columns: [
      {
        name: "file",
        label: "Arquivo"
      },
      {
        name: "from",
        label: "Origem"
      },
      {
        name: "dtcreated",
        label: "Data"
      }
    ],
  };

  list = { ...list, ...paths }

  return (
    <div>
      <CustomListContainer
        canAdd={list.canAdd}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        content={<CustomList list={list} />}
      />
    </div>
  );
}
export default List;